import { useContext } from 'react';
import { AuthContext } from '../contexts/amplify-auth-context';

export const useAuth = () => useContext(AuthContext);
